import exercisesApi from 'api/rest/exercises/exercises';
import { resolveSubjectNumericId } from 'services/common/subjectParsers/subjectParsers';
import logError from 'utils/logError/logError';

import useSubjectStore from '../subject';
import useUserPreferencesStore from '../userPreferences';

const toCurriculumList = value => {
  if (Array.isArray(value)) return value.length ? value : null;
  if (typeof value === 'string' && value) return [value];
  return null;
};

const parseVariables = base => {
  const { subject } = useSubjectStore.getState();
  const { year, month, curriculum } = base;

  return {
    subject: resolveSubjectNumericId(subject),
    curriculum: toCurriculumList(curriculum),
    year,
    month,
  };
};

const getExercisesForSheets = async variables => {
  const { setHideMarking } = useUserPreferencesStore.getState();
  setHideMarking(false);

  const { subject, curriculum, year, month } = variables;
  if (!subject || !curriculum?.length || year == null || month == null) {
    return {};
  }

  try {
    const exercises = await exercisesApi.getSheetsExercises({
      subject,
      curriculum,
      year: Number(year),
      month: Number(month),
    })();
    const [currentExercise] = exercises;
    return {
      allExercisesCompleted: false,
      exercises,
      currentExercise,
      exercisesCount: exercises.length,
      exerciseCursor: 0,
      fetched: true,
    };
  } catch (error) {
    sessionStorage.removeItem(`${import.meta.env.VITE_VERSION}_sheets`);
    window.location.href = '/';
    logError(error);
    return {};
  }
};

export { parseVariables };
export default getExercisesForSheets;
